
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/main-features/global-variants",
      function () {
        return require("private-next-pages/joy-ui/main-features/global-variants.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/main-features/global-variants"])
      });
    }
  